// extracted by mini-css-extract-plugin
module.exports = {"list":"resourceList-module--list--34OG2","listItem":"resourceList-module--listItem--aCkKw"};